//#region Imports

import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Crud } from '../../shared/services/crud/crud.service';
import { UserPayload } from '../../shared/types/payloads/user.payload';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { ButtonRadiusEnum } from '../../shared/components/button/types/button-radius.enum';
import { ButtonTypeEnum } from '../../shared/components/button/types/button-type.enum';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { AnimatedBannerComponent } from '../../shared/components/animated-banner/animated-banner.component';
import { SpinnerComponent } from '../../shared/components/spinner/spinner.component';
import { SpinnerColorEnum } from '../../shared/components/spinner/types/spinner-color.enum';
import { SpinnerSizeEnum } from '../../shared/components/spinner/types/spinner-size.enum';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../shared/services/auth/auth.service';
import { ToastService } from '../../shared/components/toast/service/toast.service';
import { EMAIL_REGEX } from '../../shared/utils/variables';

//#endregion

interface UserForm {
  email: FormControl<string>;
}

@Component({
    selector: 'l-forgot-pwd',
    templateUrl: './forgot-pwd.component.html',
    styleUrl: './forgot-pwd.component.scss',
    imports: [
        ButtonComponent,
        ReactiveFormsModule,
        IconComponent,
        AnimatedBannerComponent,
        SpinnerComponent,
        RouterLink,
    ]
})
export class ForgotPwdComponent extends Crud<UserForm> {

  public isLoading = false;

  public readonly buttonTypes = ButtonTypeEnum;

  public readonly buttonRadius = ButtonRadiusEnum;

  public readonly spinnerSize = SpinnerSizeEnum;

  public readonly spinnerColors = SpinnerColorEnum;

  public override form = new FormGroup<UserForm>(<UserForm>{
    email: new FormControl('', [Validators.required]),
  });

  public override mapField = {
    email: 'email',
  };

  private readonly authService = inject(AuthService);

  private readonly toastService = inject(ToastService);

  public get isDisabled(): boolean {
    const email = this.form.controls.email.value ?? '';
    return !EMAIL_REGEX.test(email) || this.isLoading;
  }

  public async submit(): Promise<void> {
    const payload = this.form.getRawValue() as UserPayload;

    try {
      this.isLoading = true;
      const ok = await this.authService.forgotPassword(payload.email);
      if (ok) {
        this.toastService.success('Instruções de recuperação enviadas para o email informado');
      }
    } catch (error: any) {
      this.toastService.error(error?.error?.message ?? 'Não foi possível solicitar a recuperação.');
    } finally {
      this.isLoading = false;
    }
  }

}
